export default function StickyQuoteBar() {
  return (
    <div className="hidden md:block fixed bottom-0 left-0 right-0 z-50 bg-teal-800 border-t-2 border-teal-500 shadow-2xl">
      <div className="max-w-7xl mx-auto px-6 py-3">
        <div className="flex items-center gap-6">
          {/* 직영 운영 안내 문구 */}
          <div className="flex items-center gap-3 flex-1 min-w-0">
            <div className="w-9 h-9 flex items-center justify-center bg-orange-500 rounded-full shrink-0">
              <i className="ri-truck-line text-white text-lg"></i>
            </div>
            <div className="flex flex-col">
              <span className="text-orange-300 text-xs font-semibold tracking-wide">전국 어디든 갑니다.&nbsp;</span>
              <span className="text-white font-bold text-sm">강원도에서 부산까지 — 전 지역 우리집 익스프레스 직영으로 운행합니다</span>
            </div>
          </div>

          {/* 간편견적신청 버튼 */}
          <a
            href="https://talk.naver.com/profile/wfu3m6i"
            target="_blank"
            rel="noopener noreferrer"
            className="shrink-0 bg-orange-500 hover:bg-orange-400 text-white font-bold px-8 py-5 rounded text-sm transition-colors whitespace-nowrap cursor-pointer flex flex-col items-center gap-0.5"
          >
            <i className="ri-file-list-3-line text-lg"></i>
            <span>간편견적신청</span>
          </a>

          {/* 카카오 버튼 */}
          <a
            href="https://open.kakao.com/o/sduqXZli"
            target="_blank"
            rel="noopener noreferrer"
            className="shrink-0 bg-yellow-400 hover:bg-yellow-300 text-gray-900 font-bold px-8 py-5 rounded text-sm transition-colors whitespace-nowrap cursor-pointer flex flex-col items-center gap-0.5"
          >
            <i className="ri-kakao-talk-fill text-lg"></i>
            <span>카카오 상담</span>
          </a>

          {/* 전화 */}
          <a
            href="tel:0507-1366-2424"
            className="shrink-0 flex items-center gap-3 bg-teal-700 hover:bg-teal-600 border border-teal-500 text-white px-6 py-5 rounded transition-colors whitespace-nowrap cursor-pointer"
          >
            <div className="w-9 h-9 flex items-center justify-center bg-white/20 rounded-full shrink-0">
              <i className="ri-phone-fill text-white text-lg"></i>
            </div>
            <div className="flex flex-col">
              <span className="text-xs text-teal-200">전화 상담</span>
              <span className="text-lg font-black tracking-wide">0507-1366-2424</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}
